import React, { useMemo } from "react";
import styled, { keyframes } from "styled-components";
import { curStateEventThingyan2025 } from "../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { getDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { setDataHistory } from "../../../../Redux/futures/thingyan-2025/action";
import _ from "lodash";
import { dataDetail } from "./DefineData";
import { ID_GIFT_PLAY_LOTO } from "../../../../helper/const";

function EventMarquee() {
  const { dataHistory = {} } = useSelector(curStateEventThingyan2025);
  const dispatch = useDispatch();

  const handleGetData = async () => {
    const dataApi = await getDataApi(API_PATH.thingyanReelHistory, {
      my_history: 0,
      page: 1,
      limit: 5,
    });
    dispatch(
      setDataHistory(
        (dataApi.data?.resultLast && dataApi.data?.resultLast) || {}
      )
    );
  };

  React.useEffect(() => {
    handleGetData();
  }, []);

  const context =
    useMemo(() => {
      if (_.isEmpty(dataHistory)) {
        return null;
      }
      const contentActive = dataHistory.map((itemDataHistory) => {
        const d = dataDetail.find((detail) => {
          const { srcDetailCollection } = detail;
          let isCheckPrize = false;
          srcDetailCollection.forEach((collect) => {
            if (+collect.idPiece === +itemDataHistory?.piece_id) {
              isCheckPrize = true;
            }
          });
          if (isCheckPrize) {
            return detail;
          }
        });
        const dataActive = { ...d, ...itemDataHistory };
        let content = "";

        switch (+dataActive?.award_id) {
          case ID_GIFT_PLAY_LOTO.bid_free:
            if (+dataActive?.award_value === 1) {
              content = `${dataActive?.isdn} သည် အခမဲ့ 1 ကြိမ် ကစားခွင့်ရရှိပါသည်။`;
            } else {
              content = `${dataActive?.isdn} သည် အခမဲ့ 2 ကြိမ် ကစားခွင့်ရရှိပါသည်။`;
            }
            return content;

          case ID_GIFT_PLAY_LOTO.puzzle_piece:
            content = `${dataActive?.isdn} ${dataActive?.award_name} - Piece (${dataActive?.name}) ရရှိပါသည်။`;
            return content;
          case ID_GIFT_PLAY_LOTO.good_luck:
            content = `${dataActive?.isdn} has won ${dataActive?.award_name}`;
            return content;
          case ID_GIFT_PLAY_LOTO.add_spin:
            content = `${dataActive?.isdn} သည် အခမဲ့ ${dataActive?.award_value} Coin ရရှိပါသည်။`;
            return content;
          default:
            break;
        }
        return content;
      });
      return contentActive;
    }, [dataHistory]) || [];

  if (_.isEmpty(dataHistory)) {
    return <MarqueeContainer />;
  }

  return (
    <MarqueeContainer>
      <Marquee>
        {_.isEmpty(context)
          ? null
          : context.map((item, index) => (
              <p className="marquee-text" key={`${item}_${index}`}>
                {item}
              </p>
            ))}
      </Marquee>
    </MarqueeContainer>
  );
}

const marquee = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px 0;
  margin-bottom: 12px;
  position: relative;
  z-index: 2;
`;

const Marquee = styled.div`
  display: inline-block;
  animation: ${marquee} 20s linear infinite;
  width: max-content;
  .marquee-text {
    color: white;
    display: inline-block;
    margin-right: 40px;
  }
`;

export default EventMarquee;
